import React from 'react';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';
import ContractFormService from '../services/ContractFormService';
import PropTypes from 'prop-types';
import UpfrontContractProductsList from './UpfrontContractProductsList';
import { BRAZIL } from '../../../core/consts';

class UpfrontContractProductsListContainer extends React.Component {
  static propTypes = {
    readOnly: PropTypes.bool,
    preserveCoreProducts: PropTypes.bool,
  };

  render() {
    return (
      <UpfrontContractProductsList
        readOnly={this.props.readOnly}
        preserveCoreProducts={this.props.preserveCoreProducts}
        onDelete={ContractFormService.productsService.handleDelete}
        onEdit={ContractFormService.productsService.handleEdit}
        data={toJS(ContractFormService.productsService.contractProducts)}
        loading={ContractFormService.fetch.fetching}
        submitting={ContractFormService.submit.fetching}
        currencyType={
          !ContractFormService.form.getValue('country') || BRAZIL.includes(ContractFormService.form.getValue('country'))
            ? 'real'
            : 'dollar'
        }
        isEditing={!!ContractFormService.contractId}
        onToggleProduct={ContractFormService.productsService.handleToggleProduct}
      />
    );
  }
}

export default observer(UpfrontContractProductsListContainer);
